import { collectNumbers, numericExtent, supertrendSeries } from "../utils";
const SUPERTREND = {
    name: "Supertrend",
    compute: (bars, period = 10, multiplier = 3) => {
        return supertrendSeries(bars, period, multiplier);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default SUPERTREND;
